import { Component, effect, inject, Input, OnInit } from '@angular/core';
import { ChildNotificationInterface, ItemCommunicationService, ParentTriggerInterface } from 'src/app/features/items/components/items-module/items-tab/services/item-communication.service';
import { Items } from 'tilby-models';
import { ItemInventoryFormGroups } from './item-inventory.model';
import { ItemInventoryFormService } from './item-inventory-form.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { filter, map, Observable, of, startWith } from 'rxjs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

interface UnitInterface {
  name: string;
  value: string;
}
@Component({
  selector: 'app-item-inventory',
  standalone: true,
  imports: [ MatFormFieldModule, ReactiveFormsModule,
    TranslateModule, FormsModule, CommonModule,
    MatInputModule, MatSelectModule, MatAutocompleteModule
  ],
  templateUrl: './item-inventory.component.html',
  styleUrl: './item-inventory.component.scss'
})
export class ItemInventoryComponent implements OnInit {

  private readonly itemCommunicationService = inject(ItemCommunicationService);
  readonly itemInventoryFormService = inject(ItemInventoryFormService);
  private readonly translate = inject(TranslateService);
  
  @Input() item!: Items;

  itemInventoryForm!: ItemInventoryFormGroups;

  filteredUnits: Observable<UnitInterface[]> | undefined = of([]);

  units = [{
      name: this.translate.instant('ITEMS.DETAILS.PIECES_FULL'),
      value: this.translate.instant('ITEMS.DETAILS.PIECES_SHORT')
    }, {
      name: this.translate.instant('ITEMS.DETAILS.METERS_FULL'),
      value: this.translate.instant('ITEMS.DETAILS.KILO_METERS_SHORT')
    }, {
      name: this.translate.instant('ITEMS.DETAILS.KILO_FULL'),
      value: this.translate.instant('ITEMS.DETAILS.KILO_SHORT')
    }, {
      name: this.translate.instant('ITEMS.DETAILS.LITRE_FULL'),
      value: this.translate.instant('ITEMS.DETAILS.LITRE_SHORT')
    }]
  
  constructor() {
    effect(() => {
      // Listener per eseguire operazioni richieste dal parent
      const trigger = this.itemCommunicationService.parentTrigger();
      if(trigger?.child === 'inventory') {
        this.handleParentTrigger(trigger);
      }
    })
  }

  handleParentTrigger(message: ParentTriggerInterface) {
    if (message.trigger === 'tabActivated') {
    }

    if(message.trigger === 'save') {
      this.save();
    }
    
    if(message.trigger === 'cancel') {
      this.cancel();
    }
  }

  ngOnInit(): void {
    this.itemInventoryForm = this.itemInventoryFormService.createForm(this.item);

    this.filteredUnits = this.itemInventoryFormService.unit?.valueChanges.pipe(
      startWith(null),
      filter(value => typeof value === 'string' || value === null),
      map(value => (value ? this._filterUnit(value) : this.units?.slice() || []))
    );
  }

  private _filterUnit(value: string): UnitInterface[] {
    const filterValue = value.toLowerCase();
    return this.units.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  displayUnit(unit: UnitInterface | string): string {
    return typeof unit === 'string'? unit: unit?.name? unit.name: '';
  }

  sendNotificationToParent(notification: ChildNotificationInterface) {
    Promise.resolve().then(() => {
      this.itemCommunicationService.notifyParent(notification);
    });
  }

  save() {
    this.sendNotificationToParent({notification: 'operationOutcome', params: {result: 'ko'}})
  }

  cancel() {
    this.sendNotificationToParent({notification: 'operationOutcome', params: {result: 'ok'}})
  }

  submitForm() {
  }

}
